module.exports = {"handsome":"ZZC,你好"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh.json
// module id = MvI0
// module chunks = 29